import React, { Component } from 'react'
import styled from 'styled-components'
import { Shape, DefaultText } from './'
import Icon from './Icon'

const CustomShape = styled(Shape)`
  width: 100px;
  transition: width 0.2s;
  padding: 0 6px;
  & button {
    border: none;
    background: transparent;
    font-size: 20px;
    line-height: 1.2;
    color: #124b5f;
    padding: 2px 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  ${props =>
    props.collapsed &&
    `
    width: auto;
    padding: 2px 18px;
    &>p{
      padding: 0;
    }
    &>button{
      display: none;
    }
  `};
  ${props =>
    props.disableDelete &&
    `
  &>button:first-child{
    & path{
      fill: rgba(18, 75, 95, 0.26);
    }
  }
  
  `};
`
class Counter extends Component {
  state = {}
  render() {
    const { value, onAdd, onSubtract, disableDelete, collapsed, onTouch, ...props } = this.props
    return (
      <CustomShape
        backgroundColor="transparent"
        border="1px solid #dcdcdc"
        disableDelete={disableDelete}
        collapsed={collapsed}
        onClick={event => (onTouch ? onTouch(event) : null)}
        {...props}>
        <button disabled={disableDelete} onClick={event => (onSubtract ? onSubtract(event) : null)}>
          {value <= 1 ? (
            <Icon icon="trash" color="#124b5f" />
          ) : (
            <React.Fragment>
              <span style={{ marginLeft: -2 }}>-</span>
            </React.Fragment>
          )}
        </button>
        <DefaultText color="#124b5f" padding="0 8px">
          {value}
        </DefaultText>
        <button onClick={event => (onAdd ? onAdd(event) : null)}>+</button>
      </CustomShape>
    )
  }
}

export default Counter



// WEBPACK FOOTER //
// ./src/components/Counter.js